import { render } from "./ModalSearch.vue?vue&type=template&id=37013c94&scoped=true"
import script from "./ModalSearch.vue?vue&type=script&lang=js"
export * from "./ModalSearch.vue?vue&type=script&lang=js"

import "./ModalSearch.vue?vue&type=style&index=0&id=37013c94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37013c94"]])

export default __exports__